import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';

/**
 * Requires manage_roster for the current context (team admin, owner, or manager).
 */
export const rosterManageGuard: CanActivateFn = async (): Promise<boolean> => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);

  const can = await permissions.canManageRoster();
  if (!can) {
    await router.navigate(['/roster']);
    return false;
  }
  return true;
};
